import React, { useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import { useDispatch, useSelector } from 'react-redux';
import './subscription.scss'
import { setLoader } from '../../slice/commonSlice'
import { fetchSubscriptionPlans } from '../../services/auth.service'
import SubscriptionPlan from './SubscriptionPlan'
import { selectUser } from '../../slice/authSlice';
import { useNavigate } from "react-router-dom";

const Subscription = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if(user?.isSubscribed){
      navigate('/')
    }else{
      getPlans();
    }
  }, [])

  const getPlans = async () => {
    await dispatch(setLoader(true));
    try {
      const response = await fetchSubscriptionPlans();
      await dispatch(setLoader(false));
      if (response.status) {
        setPlans(response.data?.plans);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  }




  return (
    <>
      <Header />
      <PageHeading title="Subscription" />
      <div className='main-container subscription-container'>
        <div className='container-wrap'>
          <div className='subscription-wrapper'>
            {/* <div className='price-table h-100'>
              <div className='price-table-header'>
                <div className='price-table-title'>Basic</div>
                <div className='price-wrap'>$199<span>/m</span></div>
              </div>
              <div className='plan-wrapper'>
                <h5 className='plan-title'>This plan Includes:</h5>
                <ul>
                  <li><i><BulletIcon /></i> Premium Customer Support</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> Add Unlimited Expertise</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> 24*7 Response for Contact</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> Premium Customer Support</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>

                </ul>
              </div>
              <div className='apply-wrapper'>
                <div className='apply'>
                  <InputGroup>
                    <Form.Control placeholder="Apply Promo Code" />
                    <Button variant="primary" id="button-addon2">
                      Apply
                    </Button>
                  </InputGroup>
                </div>
                <div className='w-100 d-grid pay-wrap'><Button variant='outline-primary'>Pay Now</Button></div>
              </div>
            </div>
            <div className='price-table h-100 active'>
              <div className='price-table-header'>
                <div className='price-table-title'>Standard</div>
                <div className='price-wrap'>$299<span>/m</span></div>
              </div>
              <div className='plan-wrapper'>
                <h5 className='plan-title'>This plan Includes:</h5>
                <ul>
                  <li><i><BulletIcon /></i> Premium Customer Support</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> Add Unlimited Expertise</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> 24*7 Response for Contact</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> Premium Customer Support</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>

                </ul>
              </div>
              <div className='apply-wrapper'>
                <div className='apply'>
                  <InputGroup>
                    <Form.Control placeholder="Apply Promo Code" />
                    <Button variant="primary" id="button-addon2">
                      Apply
                    </Button>
                  </InputGroup>
                </div>
                <div className='w-100 d-grid pay-wrap'><Button variant='primary'>Pay Now</Button></div>
              </div>
            </div>
            <div className='price-table h-100'>
              <div className='price-table-header'>
                <div className='price-table-title'>Premium</div>
                <div className='price-wrap'>$399<span>/m</span></div>
              </div>
              <div className='plan-wrapper'>
                <h5 className='plan-title'>This plan Includes:</h5>
                <ul>
                  <li><i><BulletIcon /></i> Premium Customer Support</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> Add Unlimited Expertise</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> 24*7 Response for Contact</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>
                  <li><i><BulletIcon /></i> Premium Customer Support</li>
                  <li><i><BulletIcon /></i> Unlimited Requests</li>

                </ul>
              </div>
              <div className='apply-wrapper'>
                <div className='apply'>
                  <InputGroup>
                    <Form.Control placeholder="Apply Promo Code" />
                    <Button variant="primary" id="button-addon2">
                      Apply
                    </Button>
                  </InputGroup>
                </div>
                <div className='w-100 d-grid pay-wrap'><Button variant='outline-primary'>Pay Now</Button></div>
              </div>
            </div> */}
            {
              plans?.length > 0 ?
                <>
                  {
                    plans?.map((plan, index) => (
                      <SubscriptionPlan
                        key={index}
                        plan={plan}
                      />
                    ))
                  }
                </>
                : <p>No plan available</p>
            }
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Subscription